import { Source, SourceType } from '../src/constants/Source';

export const getScreenFromUrl = (
  url: URL = new URL(window.location.href),
): SourceType => {
  const firstPathSegment = url.pathname.split('/')[1];
  let screen: SourceType;

  if (firstPathSegment === 'b') {
    screen = Source.boardScreen;
  } else if (firstPathSegment === 'c') {
    screen = Source.cardDetailScreen;
  } else if (firstPathSegment === 'power-ups') {
    screen = Source.publicDirectoryScreen;
  } else if (/^search/.test(firstPathSegment)) {
    screen = Source.searchResultsScreen;
  } else if (url.pathname.includes('billing')) {
    screen = Source.teamBillingScreen;
  } else if (url.pathname.includes('home')) {
    screen = Source.teamScreen;
  } else if (firstPathSegment === 'shortcuts') {
    screen = Source.shortcutsScreen;
  } else if (url.pathname === '/') {
    screen = Source.memberHomeScreen;
  } else {
    screen = Source.unknownScreen;
  }

  return screen;
};
